import { Reveal } from "@/components/Reveal";
import { PACKAGES } from "@/data/content";
import { Check } from "lucide-react";

export const Pricing = () => {
  const scrollContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-background py-24 sm:py-32 lg:py-44"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-2xl mb-16 sm:mb-24">
          <Reveal>
            <p className="overline mb-6">Prices</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground leading-none">
              Considered pricing, no surprises.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PACKAGES.map((pkg, i) => (
            <Reveal key={pkg.name} delay={i * 0.12}>
              <div
                data-testid={`pricing-card-${i}`}
                className={`h-full flex flex-col p-9 lg:p-11 transition-colors duration-500 ${
                  pkg.featured
                    ? "bg-[#111111] text-[#F7F5F0]"
                    : "border border-border text-foreground hover:border-foreground"
                }`}
              >
                {pkg.featured && (
                  <span className="overline text-[#C9BCA8] mb-6">
                    Most Commissioned
                  </span>
                )}
                <h3 className="font-display font-light text-3xl leading-none">
                  {pkg.name}
                </h3>
                <p
                  className={`mt-4 text-sm leading-relaxed ${
                    pkg.featured ? "text-[#F7F5F0]/60" : "text-muted-foreground"
                  }`}
                >
                  {pkg.summary}
                </p>

                <div className="mt-9 flex items-baseline gap-2">
                  <span className="font-display text-5xl font-light">
                    {pkg.price}
                  </span>
                  <span
                    className={`text-xs tracking-wide ${
                      pkg.featured ? "text-[#F7F5F0]/50" : "text-muted-foreground"
                    }`}
                  >
                    {pkg.unit}
                  </span>
                </div>

                <div
                  className={`my-9 h-px ${
                    pkg.featured ? "bg-[#F7F5F0]/15" : "bg-border"
                  }`}
                />

                <ul className="space-y-4 flex-1">
                  {pkg.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm">
                      <Check
                        strokeWidth={1.25}
                        className={`w-4 h-4 mt-0.5 shrink-0 ${
                          pkg.featured ? "text-accent" : "text-accent"
                        }`}
                      />
                      <span
                        className={
                          pkg.featured ? "text-[#F7F5F0]/80" : "text-foreground/80"
                        }
                      >
                        {f}
                      </span>
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`pricing-cta-${i}`}
                  onClick={scrollContact}
                  className={`mt-11 w-full py-4 text-xs tracking-[0.18em] uppercase transition-all duration-300 ${
                    pkg.featured
                      ? "bg-[#F7F5F0] text-[#1A1A1A] hover:bg-accent hover:text-[#F7F5F0]"
                      : "border border-foreground text-foreground hover:bg-foreground hover:text-background"
                  }`}
                >
                  Enquire
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
